module.exports = __webpack_public_path__ + "img/document.0f8679cb.svg";